import { render, staticRenderFns } from "./wine-barrel.vue?vue&type=template&id=77a317e2"
import script from "./wine-barrel.vue?vue&type=script&lang=js"
export * from "./wine-barrel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports